module.exports = __webpack_public_path__ + "50663e629d5b2ccc65e421e00388b274.png";